
import React, { useState } from 'react';
import { CpIcon, CpModal, CpButton } from 'canopy-styleguide!sofe';
import { useSwitchUser } from './switch-user.hook';
import { noop } from 'lodash'
import { m } from 'kremling'
import styles from './nav-profile-switch-user.styles.css'

export const NavProfileSwitchUser = ({entities, setSwitchingUser}) => {
  const [openChickenSwitch, setOpenChickenSwitch] = useState(null)
  const setSwitchUser = useSwitchUser();

  return (
    <div className="cp-select-list">
    <button onClick={() => setSwitchingUser(false)} >
      <CpIcon name="caret-large-left" className="cp-select-list__icon-left" />
      <span className="cp-select-list__content cps-wt-semibold cp-color-app-secondary-text">Back</span>
    </button>
    {entities.map(user => {
      return (
        <a key={user.id} onClick={user.isActive ? noop : () => setOpenChickenSwitch(user)} className={m(styles.activeUser, user.isActive)}>
          <div className="cp-select-list__content cp-flex-column">
            <div className='cps-body'>{user.company_name}</div>
            <i className='cps-caption cp-color-app-secondary-text'>{user.profile_name || user.name}</i>
          </div>
          {user.isActive && (
            <CpIcon
              name="checkmark-circle-filled-small"
              fill="var(--cps-color-success)"
              className='cp-select-list__icon-right'
            />
          )}
        </a>
      )
    })}
    <CpModal show={!!openChickenSwitch} onClose={() => setOpenChickenSwitch(null)}>
      <CpModal.Header title={'Switch Account'}/>
      <CpModal.Body className='cp-body'>
        By continuing with switching accounts, any unsaved data on all tabs and windows for this browser will be lost.
      </CpModal.Body>
      <CpModal.Footer>
        <CpButton btnType="primary" onClick={() => setSwitchUser(openChickenSwitch)}  className='cp-mr-8'>
          Switch account
        </CpButton>
        <CpButton btnType="flat" onClick={() => setOpenChickenSwitch(null)}>
          Cancel
        </CpButton>
      </CpModal.Footer>
    </CpModal>
  </div>
  )
}
